import { all, fork, takeLatest, call, put } from 'redux-saga/effects';

import feedDataLayer from 'features/feedDataLayer/state/sagas';
import { handlerErrors } from 'state/shared/sagas';
import iclinic from 'services/iclinic';
import {
  getLatestDiagnoses,
  getPatientHeader,
} from 'features/records/services';
import memedSagas from './memed/sagas';
// eslint-disable-next-line import/no-cycle
import signatureSagas from './signature/sagas';
import attachmentsSagas from './attachments/sagas';
import highlightsInfoSagas from '../../features/highlightsInfo/state/sagas';
import * as types from './types';
import * as actions from './actions';
import { patientHeaderServiceResponseAdapter } from './utils';

export function* workerGetEventsBlocksIds({ payload: { eventId, patientId } }) {
  try {
    const { getResponseData, errors } = yield call(
      iclinic.records.getResumeRecords,
      patientId,
      eventId,
    );

    if (errors) throw errors;
    const responseEventsResume = getResponseData();

    yield put(
      actions.getEventBlocksIdsSuccess(responseEventsResume, patientId),
    );
  } catch (error) {
    yield call(handlerErrors, error, actions.getEventBlocksIdsFailure);
  }
}

export function* workerGetLatestDiagnoses({ payload: { patientId } }) {
  try {
    const { data, errors } = yield call(getLatestDiagnoses, patientId);

    if (errors) throw errors;

    yield put(actions.getLatestDiagnosesSuccess(data));
  } catch (error) {
    yield call(handlerErrors, error, actions.getLatestDiagnosesFailure);
  }
}

export function* workerGetPatientHeader({ payload: { patientId } }) {
  try {
    const { data, errors } = yield call(getPatientHeader, patientId);

    if (errors) throw errors;

    const patientSummary = patientHeaderServiceResponseAdapter(data);
    yield put(actions.getPatientHeaderSuccess(patientSummary));
  } catch (e) {
    yield put(actions.getPatientHeaderFailed());
  }
}

export default function* recordSagas() {
  yield all([
    yield fork(memedSagas),
    yield fork(attachmentsSagas),
    yield fork(signatureSagas),
    yield fork(highlightsInfoSagas),
    yield fork(feedDataLayer),
    yield takeLatest(
      types.GET_EVENT_BLOCKS_IDS.ACTION,
      workerGetEventsBlocksIds,
    ),
    yield takeLatest(
      types.GET_LATEST_DIAGNOSES.ACTION,
      workerGetLatestDiagnoses,
    ),
    yield takeLatest(types.GET_PATIENT_HEADER.ACTION, workerGetPatientHeader),
  ]);
}
